(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    let phoneInputField = document.querySelector("#ContactForm-phone");
  phoneInput = window.intlTelInput(phoneInputField, {
    initialCountry: "lk",
    preferredCountries: ["lk"],
    utilsScript:
      "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
  });
  

  window.addEventListener("load", e=>{
    const virtualForm = document.createElement("form");
    virtualForm.action = "/contact";
    virtualForm.method = "post";

    window.Shopify.captcha.protect(virtualForm, e => {
      console.log("Shopify protect script ready.");

      const siteKey = virtualForm.querySelector("div.h-captcha").dataset.sitekey;
      let latestToken = ""; 

      const forms = document.querySelectorAll(".ecom-custom-hcaptcha-form");
      
      forms.forEach(form => {
        // Inject hidden input
        if (!form.querySelector('input[name="form_type"]')) {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = "form_type";
          hiddenInput.value = "contact";
          form.appendChild(hiddenInput);
        }

        // 1. Find the actual submit button inside this specific form
        const submitBtn = form.querySelector('[type="submit"]');

        if (submitBtn) {
          // 2. Listen to the click event on the button instead of form submit
          submitBtn.addEventListener("click", function(event) {
            
            // Step A: Check HTML5 validation (required fields, emails, etc.)
            if (!form.checkValidity()) {
              // If native validation fails, trigger the browser's default warning bubble 
              // and stop everything here.
              form.reportValidity(); 
              event.preventDefault();
              return;
            }

            // Step B: Check if hCaptcha is solved
            if (!latestToken) {
              event.preventDefault(); // Strongly block the click execution
              event.stopPropagation(); // Stop event bubbling
              
              alert("Please validate captcha");
              return false;
            }

            // Step C: Everything is good! Inject the token into the form
            let responseInput = form.querySelector('textarea[name="h-captcha-response"]');
            if (!responseInput) {
              responseInput = document.createElement("textarea");
              responseInput.name = "h-captcha-response";
              responseInput.style.display = "none";
              form.appendChild(responseInput);
            }
            responseInput.value = latestToken;

            // Step D: Explicitly submit the form now that it is fully verified
            form.submit();
          });
        }
      });

      // Render the hCaptcha
      function renderForcedCaptcha() {
        if (window.hcaptcha) {
          window.hcaptcha.render("captcha-container", {
            sitekey: siteKey,
            size: "normal", 
            rqdata: btoa("force_challenge_" + Date.now() + Math.random()),
            callback: function(token) {
              latestToken = token; 
            },
            "expired-callback": function() {
              latestToken = ""; 
              window.hcaptcha.reset(); 
            }
          });
        } else {
          setTimeout(renderForcedCaptcha, 100);
        }
      }

      renderForcedCaptcha();
    });

  })
  } catch(e) { console.error(e); }
})();

})();
